import { render, staticRenderFns } from "./AddDoctypeModal.vue?vue&type=template&id=08df18d4&"
import script from "./AddDoctypeModal.vue?vue&type=script&lang=js&"
export * from "./AddDoctypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports